import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { BasicGroup } from "config/constants.config";
import { buildUpdatingEstimateBasicItemsSelector } from "store/entities/estimates";

import ItemsWrapper from "../ItemsWrapper/ItemsWrapper";
import { useAssociatedItems } from "common/hooks/useAssociatedItems";


export default function GutterStep({ estimate, patch }) {
  const guttersSelector = useMemo(
    () => buildUpdatingEstimateBasicItemsSelector(BasicGroup.GUTTER),
    [estimate.id, estimate.type]
  );
  const estimateGutters = useSelector(guttersSelector);
  const { loaded } = useAssociatedItems();

  if (!loaded)
    return <div style={{ padding: 24 }}>Loading items...</div>;

  return (
    <ItemsWrapper
      estimate={estimate}
      patch={patch}
      data={estimateGutters}
      group={BasicGroup.GUTTER}
      entityName="gutter"
    />
  );
}
